export function addTwoHoursToDate (date) {
    date = new Date(date + 'Z')
    return date.getHours() + 2 + ':' + date.getMinutes().toString().padStart(2, '0')
}


export function formatDateTimeUTC (date) {
    date = new Date(date)
    return date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0')
}

export function formatDateString (inputDate) {
    const parsedDate = new Date(inputDate)
    const reformattedDate = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate() + 1, 0, 0, 0, 0)
    const formattedDateString = reformattedDate.toISOString().split('T')[0]
    return formattedDateString
}

export function formatDate(date, locale = navigator.language, options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
}) {
    if (!date) return '';
    return new Intl.DateTimeFormat(locale, options).format(new Date(date));
}

export function formatLocalizedDate(date, locale = navigator.language) {
    if (!date) return '';
    // Get the locale's date format pattern
    const format = new Intl.DateTimeFormat(locale).formatToParts(new Date()).map(({type, value}) => {
        switch (type) {
            case 'month': return 'MM';
            case 'day': return 'DD';
            case 'year': return 'YYYY';
            default: return value;
        }
    }).join('');
    
    return new Date(date).toLocaleDateString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
}

export function formatDateTime(date, locale = navigator.language) {
    date = new Date(date + 'Z')
    return new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
    }).format(date)
}

export function formatDateTimeZ(date, locale = navigator.language) {
    date = new Date(date)
    return new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
    }).format(date)
}